export function getItemsPage (getItemsFn, state, generalHandler = () => true) {
  const cachedState = angular.copy(state)
  return function getItemsCallback (array, isInit = true, params = {}, handler = generalHandler) {
    if (isInit) {
      Object.assign(state, cachedState, params, { page: 0 })
      array.length = 0
    } else {
      state.page++
    }
    getItemsFn(state)
      .then(result => {
        array.push(...result.content.filter(handler))
        state.last = result.last
        if (!result.last && array.length < state.count * 0.6) {
          getItemsCallback(array, false, params, handler)
        }
      })
  }
}
